import type { PayloadAction } from '@reduxjs/toolkit';
import type { CalculationError } from '@snap-types/models/auto-configurator/state';

import { WritableAutoConfiguratorState } from '../slice';

type SetCalculationErrorPayload = {
  lineItemUuid: string;
  error: CalculationError;
};

type ClearCalculationErrorPayload = {
  lineItemUuid: string;
};

const MAX_CALCULATION_ERROR_TITLE_LENGTH = 120;
const MAX_CALCULATION_ERROR_DESCRIPTION_LENGTH = 320;

export function setCalculationError(
  state: WritableAutoConfiguratorState,
  action: PayloadAction<SetCalculationErrorPayload>,
) {
  const { lineItemUuid, error } = action.payload;

  if (!state.lineItems[lineItemUuid]) {
    return;
  }

  state.calculationErrorsByLineItemUuid[lineItemUuid] = {
    title: truncateText(error.title, MAX_CALCULATION_ERROR_TITLE_LENGTH),
    description: error.description
      ? truncateText(
          error.description,
          MAX_CALCULATION_ERROR_DESCRIPTION_LENGTH,
        )
      : undefined,
  };
}

export function clearCalculationError(
  state: WritableAutoConfiguratorState,
  action: PayloadAction<ClearCalculationErrorPayload>,
) {
  delete state.calculationErrorsByLineItemUuid[action.payload.lineItemUuid];
}

function truncateText(value: string, maxLength: number): string {
  const normalizedValue = value.replace(/\s+/gu, ' ').trim();

  if (normalizedValue.length <= maxLength) {
    return normalizedValue;
  }

  return `${normalizedValue.slice(0, maxLength - 3).trimEnd()}...`;
}
